// Show / Hide content on responsive
var responsiveToggle = function(){

    var breakPoint320    = 1023;
    var responsiveSwitch = $('.tv-js-company-responsiveToggle');
    var responsiveOpen   = 'tv-company-responsiveToggle--open';

    if ($(window).width() < breakPoint320){

        responsiveSwitch.on('click', function(){
            if ($(this).hasClass(responsiveOpen)){
                $(this).removeClass(responsiveOpen);
                $(this).find('> div').slideUp();
            }else{
                $(this).addClass(responsiveOpen);
                $(this).find('> div').slideDown();
            }
        });

    }

}

$(document).ready(function(){
    responsiveToggle();
});
